export default __webpack_public_path__ + "static/media/icon-results.ce639d94.svg";